export class MakerMasterModel {

    // メーカーのリスト
    makers: Array<any> = [];
}